import { createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withModifiers as _withModifiers, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "row align-items-center" }
const _hoisted_2 = { class: "col-xl-4 col-lg-5 col-md-6" }
const _hoisted_3 = { class: "header-left-side justify-content-center justify-content-md-start d-flex align-items-center" }
const _hoisted_4 = {
  class: "search-box position-relative",
  ref: "searchBoxRef"
}
const _hoisted_5 = { class: "input-group" }
const _hoisted_6 = {
  key: 0,
  class: "search-dropdown"
}
const _hoisted_7 = ["onMousedown"]
const _hoisted_8 = {
  key: 1,
  class: "search-dropdown"
}
const _hoisted_9 = { class: "col-xl-8 col-lg-7 col-md-6" }
const _hoisted_10 = { class: "header-right-side d-flex align-items-center justify-content-center justify-content-md-end" }
const _hoisted_11 = { class: "dropdown profile-dropdown" }
const _hoisted_12 = {
  class: "dropdown-toggle text-start fs-14 text-black-emphasis d-flex align-items-center p-0 position-relative bg-transparent border-0 transition lh-1",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_13 = ["src"]
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "title d-none d-lg-block ms-10 ms-lg-15" }
const _hoisted_16 = { class: "d-block fw-bold mb-5 mb-md-8" }
const _hoisted_17 = { class: "dropdown-menu rounded-0 bg-white border-0 start-auto end-0" }
const _hoisted_18 = { class: "ps-0 mb-0 list-unstyled dropdown-body" }
const _hoisted_19 = { class: "text-body-secondary fw-semibold transition position-relative" }
const _hoisted_20 = { class: "text-body-secondary fw-semibold transition position-relative" }
const _hoisted_21 = { class: "text-body-secondary fw-semibold transition position-relative" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LightDarkSwtichBtn = _resolveComponent("LightDarkSwtichBtn")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass([
      'header-area bg-white text-center text-md-start pt-15 pb-15 ps-15 pe-15 ps-md-20 pe-md-20 pe-lg-30 transition mb-25 position-fixed',
      { sticky: _ctx.isSticky },
    ]),
    id: "header"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: "header-burger-menu transition position-relative lh-1 bg-transparent p-0 border-0",
            id: "header-burger-menu",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.onChange && _ctx.stateStoreInstance.onChange(...args)))
          }, _cache[9] || (_cache[9] = [
            _createElementVNode("i", { class: "flaticon-menu-3" }, null, -1)
          ])),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control shadow-none rounded-0 border-0",
                placeholder: "Rechercher une page...",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchQuery) = $event)),
                onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.searchOpen = true)),
                onKeydown: [
                  _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.closeSearch && _ctx.closeSearch(...args)), ["escape"])),
                  _cache[4] || (_cache[4] = _withKeys(
//@ts-ignore
(...args) => (_ctx.goToFirst && _ctx.goToFirst(...args)), ["enter"])),
                  _cache[5] || (_cache[5] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.highlightNext && _ctx.highlightNext(...args)), ["prevent"]), ["down"])),
                  _cache[6] || (_cache[6] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.highlightPrev && _ctx.highlightPrev(...args)), ["prevent"]), ["up"]))
                ],
                autocomplete: "off"
              }, null, 544), [
                [_vModelText, _ctx.searchQuery]
              ]),
              _createElementVNode("button", {
                class: "default-btn position-relative transition border-0 fw-medium text-white pt-8 pb-8 ps-15 pe-15 pt-md-12 pb-md-12 ps-md-20 pe-md-20",
                type: "button",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.goToFirst && _ctx.goToFirst(...args)))
              }, _cache[10] || (_cache[10] = [
                _createElementVNode("i", { class: "flaticon-search-interface-symbol" }, null, -1)
              ]))
            ]),
            (_ctx.searchOpen && _ctx.searchQuery.trim() && _ctx.filteredPages.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredPages, (page, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: page.path,
                      class: _normalizeClass(["search-result-item", { 'search-result-item--active': i === _ctx.highlightIndex }]),
                      onMousedown: _withModifiers(($event: any) => (_ctx.navigateTo(page.path)), ["prevent"])
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass([page.icon, "search-result-icon"])
                      }, null, 2),
                      _createElementVNode("span", null, _toDisplayString(page.name), 1)
                    ], 42, _hoisted_7))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_ctx.searchOpen && _ctx.searchQuery.trim() && !_ctx.filteredPages.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _cache[11] || (_cache[11] = [
                  _createElementVNode("div", { class: "search-no-result" }, "Aucun résultat trouvé", -1)
                ])))
              : _createCommentVNode("", true)
          ], 512)
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_LightDarkSwtichBtn),
          _cache[18] || (_cache[18] = _createStaticVNode("<div class=\"dropdown notification-dropdown\" data-v-6650e73e><button class=\"dropdown-toggle p-0 position-relative bg-transparent border-0 transition lh-1\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\" data-v-6650e73e><i class=\"flaticon-bell-2\" data-v-6650e73e></i><span class=\"dot-badge position-absolute fw-bold rounded-circle text-white bg-primary d-inline-block\" data-v-6650e73e> 0 </span></button><div class=\"dropdown-menu rounded-0 bg-white border-0 start-auto end-0\" data-v-6650e73e><div class=\"title d-flex align-items-center justify-content-between\" data-v-6650e73e><span class=\"text-black fw-bold\" data-v-6650e73e>Notifications <span class=\"text-muted\" data-v-6650e73e>(00)</span></span></div><ul class=\"ps-0 mb-0 list-unstyled dropdown-body\" data-v-6650e73e></ul></div></div>", 1)),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("button", _hoisted_12, [
              (_ctx.user?.pic)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _ctx.user.pic,
                    class: "rounded",
                    width: "44",
                    height: "44",
                    alt: "admin"
                  }, null, 8, _hoisted_13))
                : (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: require('@/assets/images/NoImage.png'),
                    class: "rounded",
                    width: "44",
                    height: "44",
                    alt: "admin"
                  }, null, 8, _hoisted_14)),
              _createElementVNode("span", _hoisted_15, [
                _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.user?.name), 1),
                _cache[12] || (_cache[12] = _createElementVNode("span", { class: "text-body-emphasis fw-semibold fs-13" }, "Admin", -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("ul", _hoisted_18, [
                _createElementVNode("li", _hoisted_19, [
                  _cache[13] || (_cache[13] = _createElementVNode("i", { class: "flaticon-user-2" }, null, -1)),
                  _cache[14] || (_cache[14] = _createTextVNode(" Mon compte ", -1)),
                  _createVNode(_component_router_link, {
                    to: "/profile",
                    class: "d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                  })
                ]),
                _createElementVNode("li", _hoisted_20, [
                  _cache[15] || (_cache[15] = _createElementVNode("i", { class: "flaticon-setting" }, null, -1)),
                  _cache[16] || (_cache[16] = _createTextVNode(" Paramètres ", -1)),
                  _createVNode(_component_router_link, {
                    to: "/account-settings",
                    class: "d-block position-absolute start-0 top-0 end-0 bottom-0 text-decoration-none"
                  })
                ]),
                _createElementVNode("li", _hoisted_21, [
                  _cache[17] || (_cache[17] = _createElementVNode("i", { class: "flaticon-logout" }, null, -1)),
                  _createElementVNode("button", {
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.handleLogout())),
                    class: "btn border-0 bg-transparent p-0 fw-semibold text-body-secondary w-100 text-start"
                  }, " Déconnexion ")
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ], 2))
}